const createPlacesService = (element) => {
  var _a, _b, _c, _d, _e, _f;
  if (!((_c = (_b = (_a = window.google) == null ? void 0 : _a.maps) == null ? void 0 : _b.places) == null ? void 0 : _c.AutocompleteService))
    throw new Error(
      "[createPlacesService] AutocompleteService is not available. Please make sure that you have added the google map script to the page and have included the places lib (`&libraries=places`)"
    );
  if (!((_f = (_e = (_d = window.google) == null ? void 0 : _d.maps) == null ? void 0 : _e.places) == null ? void 0 : _f.PlacesService))
    throw new Error(
      "[createPlacesService] PlacesService is not available. Please make sure that you have added the google map script to the page and have included the places lib (`&libraries=places`)"
    );
  if (!element)
    throw new Error("[createPlacesService] `element` of type HTMLDivElement was not provided.");
  const autocompleteService = new window.google.maps.places.AutocompleteService();
  const placesService = new window.google.maps.places.PlacesService(element);
  const getPlaceDetails = (options) => {
    return new Promise((resolve, reject) => {
      placesService.getDetails(options, (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          return resolve(result);
        } else {
          return reject(status);
        }
      });
    });
  };
  const getPlacePredictions = (options) => {
    return new Promise((resolve, reject) => {
      autocompleteService.getPlacePredictions(options, (result, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          return resolve(result || []);
        } else {
          return reject(status);
        }
      });
    });
  };
  return { getPlaceDetails, getPlacePredictions };
};
export {
  createPlacesService as default
};
